import { Sparkles } from "lucide-react";

export const CalculatorIntro = () => (
  <>
    <span className="inline-flex items-center gap-2 rounded-full border border-emerald-500/30 bg-emerald-500/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-emerald-400">
      <Sparkles className="h-3.5 w-3.5" /> Apollo.AI
    </span>
    <h2 data-testid="calculator-title" className="mt-5 max-w-3xl text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
      Preventivo Solare Istantaneo con Analisi Satellitare del Tetto
    </h2>
    <p className="mt-5 max-w-2xl text-base text-slate-400 sm:text-lg">Scopri il tuo impianto con Apollo.AI: calcolo del potenziale energetico del tetto, pannelli, potenza e fattibilità in base alla tua zona e ai tuoi consumi.</p>
  </>
);
